export const types = [
    { label: 'Od ceny hurtowej', name: 'DealersPriceRebate' },
    { label: 'Od ceny katalogowej', name: 'ListPriceRebate' },
];
